module.exports = __webpack_public_path__ + "static/media/video-guilt-es.9b820a0b.vtt";